"use client";
import React,{useState} from 'react'
import { ProductProvider } from '../components/Productcontext'
import Producthomecontent from '../components/Producthomecontent'
import Footer from '../components/Footer'
import PreHeader from '../components/PreHeader';
import Header from '../components/Header';
import Menu from '../components/Menu';
import AseelHdearthing from '../components/AseelHdearthing';
import InstallationBanner from '../components/InstallationBanner';
import ProductsubMenu from '../components/ProductsubMenu';
import hdban from '../images/earthing/hd/hotdip_galvanized_page_banner.jpg';
import hdban_360 from '../images/earthing/hd/hotdip_galvanized_page_banner_360.jpg';
import hdban_tab from '../images/earthing/hd/hotdip_galvanized_page_banner_tab.jpg';
import hdban_2x from '../images/earthing/hd/hotdip_galvanized_page_banner@2x.jpg';

// import ban1x from '../images/producthome/product-home-banner.jpg';
// import ban2x from '../images/producthome/product-home-banner@2x.jpg';
const HDGalvanizedPage = () => {
    return (
      <div>
           <ProductProvider>
          {/* <PreHeader/>
          <Header/>    
           <Menu/> */}
           <InstallationBanner page="installation" banalt="Galvanized Earthing Electrodes by Ashlok Safe Earthing Electrode Limited for Long-lasting Earthing Systems" apostropheBefore=""  apostropheAfter="" ban1x={hdban} ban2x={hdban_2x} ban360={hdban_360} bantab={hdban_tab}/>
                <ProductsubMenu/>
               
          <AseelHdearthing/>
           
           <Footer/>
           </ProductProvider>
      </div>
    )
  }
  
  export default HDGalvanizedPage
 
